import { useForm } from '@conform-to/react'
import { parseWithZod } from '@conform-to/zod'
import { useSearchParams } from '@remix-run/react'
import { useTranslation } from 'react-i18next'
import { useDebounceFetcher } from 'remix-utils/use-debounce-fetcher'
import {
	SEARCH_FORM,
	SEARCH_INPUTS,
	searchSchema,
} from '#app/components/forms/search-form/search-form.tsx'
import { ROOT_I18NEXT, ROOT_INPUTS } from '#app/routes/_layout/route-config.ts'
import { SEARCH_SEARCH_PARAMS } from '#app/routes/_layout/search'

function useSearchForm() {
	const [searchParams] = useSearchParams()
	const { t } = useTranslation(ROOT_I18NEXT.routeRoot)

	const fetcherKey = SEARCH_FORM.subaction
	const fetcher = useDebounceFetcher()

	const formValues = {
		[ROOT_INPUTS.subaction]: SEARCH_FORM.subaction,
		[ROOT_INPUTS.noJs]: 'false',
		[SEARCH_INPUTS.q]: searchParams.get(SEARCH_SEARCH_PARAMS.q) || undefined,
	}
	const [form, fields] = useForm({
		onValidate({ formData }) {
			return parseWithZod(formData, { schema: searchSchema })
		},
		shouldValidate: 'onSubmit',
	})

	return {
		searchFetcherKey: fetcherKey,
		searchFetcher: fetcher,
		searchFormValues: formValues,
		searchForm: form,
		searchFields: fields,
		t,
	}
}

export { useSearchForm }
